import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import configs from "config";
import Seo from "seo/Seo";
import { metaForPath } from "seo/meta";
import HomeVintage from "containers/HomeVintage";
import Novidades from "containers/Novidades";
import Shop from "containers/Shop";
import Sale from "containers/Sale";
import SellWithUs from "containers/SellWithUs";
import Faq from "containers/Faq";
import GiveMe from "containers/GiveMe";
import Termos from "containers/Termos";
import Conta from "containers/Conta";
import Cart from "containers/Cart";
import ProductDetails from "containers/ProductDetails";
import Checkout from "containers/Checkout";
import ResetPassword from "containers/ResetPassword";
import OrderDetails from "components/OrderDetails";
import TakeMeAround from "containers/TakeMeAround";
import TakeMeSelection from "containers/TakeMeSelection";
import BrandList from "containers/BrandList";
import ConfirmEmail from "containers/ConfirmEmail";
import About from "containers/About";

// Dispara um pageview no GA a cada troca de rota.
// Antes, o App.js mandava um único pageview fixo em "/" no carregamento, então toda a
// navegação dentro do site (SPA) ficava invisível no GA — todas as rotas apareciam como "/".
// Precisa ficar DENTRO do BrowserRouter, porque useLocation só existe no contexto do router.
// O page_title não é enviado de propósito: o gtag usa o document.title do momento do disparo,
// que é o valor correto sem precisarmos sincronizar com quem escreve o título.
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!configs.ga_mesuarement) return;
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

// Aplica título, descrição e canonical da rota atual, lendo o mapa em seo/meta.js.
// Fica centralizado aqui em vez de espalhado por 20 containers: uma rota nova só
// precisa de uma linha no mapa, e não há como esquecer de colocar o SEO na página.
// Retorna null nas rotas que montam o próprio SEO com dado dinâmico (/product/:id).
const RouteSeo = () => {
  const location = useLocation();
  const meta = metaForPath(location.pathname);

  if (!meta) return null;
  return <Seo {...meta} path={location.pathname} />;
};

const RoutesComponent = () => {
  return (
    <BrowserRouter>
      <RouteTracker />
      <RouteSeo />
      <Routes>
        <Route exact index path="/" element={<HomeVintage />} />
        <Route exact index path="/novidades" element={<Novidades />} />
        <Route exact index path="/shop" element={<Shop />} />
        <Route exact index path="/sale" element={<Sale />} />
        <Route exact index path="/sellwithus" element={<SellWithUs />} />
        <Route exact index path="/giveme" element={<GiveMe />} />
        <Route exact index path="/conta" element={<Conta />} />
        <Route exact index path="/order/:id" element={<OrderDetails />} />
        <Route
          exact
          path="/password/reset/:token/"
          element={<ResetPassword />}
        />
         <Route
          exact
          path="/confirm/email/:token/"
          element={<ConfirmEmail />}
        />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route exact index path="/cart" element={<Cart />} />
        <Route exact index path="/checkout" element={<Checkout />} />
        <Route exact index path="/faq" element={<Faq />} />
        <Route exact index path="/termos" element={<Termos />} />
        <Route exact index path="/about" element={<About />} />
        <Route exact index path="/around" element={<TakeMeAround />} />
        <Route exact index path="/selection" element={<TakeMeSelection />} />
        <Route exact index path="/brandlist" element={<BrandList />} />
        
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesComponent;
